import { IDataContextProvider } from "@contexts/data/types";

export interface PreviewData {
  isValid: boolean;
  authUrl?: string;
  token?: string;
  redirectPath?: string;
  error?: string;
}

export const previewService = (dataProvider: IDataContextProvider) => ({
  getDealPreviewData: async (dealId: number): Promise<PreviewData> => {
    try {
      const baseUrl = dataProvider.getApiUrl();
      const response = await dataProvider.custom?.({
        method: "get",
        url: `${baseUrl}/preview/deal/${dealId}`,
      });
      return (response?.data as PreviewData) || { isValid: false, error: "No data received" };
    } catch (error) {
      console.error("Error getting preview data:", error);
      return {
        isValid: false,
        error: "Failed to get preview data",
      };
    }
  },
  getSellerPreviewData: async (sellerId: number): Promise<PreviewData> => {
    try {
      const baseUrl = dataProvider.getApiUrl();
      const response = await dataProvider.custom?.({
        method: "get",
        url: `${baseUrl}/preview/seller/${sellerId}`,
      });
      return (response?.data as PreviewData) || { isValid: false, error: "No data received" };
    } catch (error) {
      console.error("Error getting preview data:", error);
      return {
        isValid: false,
        error: "Failed to get preview data",
      };
    }
  },

  openPreviewWindow: (authUrl: string, token: string, redirectPath: string): void => {
    // Create a hidden form for posting the JWT token
    const form = document.createElement("form");
    form.method = "POST";
    form.action = authUrl;
    form.target = "_blank"; // Open in new window
    form.style.display = "none";

    // Add token field
    const tokenField = document.createElement("input");
    tokenField.type = "hidden";
    tokenField.name = "token";
    tokenField.value = token;
    form.appendChild(tokenField);

    // Add redirect field
    const redirectField = document.createElement("input");
    redirectField.type = "hidden";
    redirectField.name = "redirect";
    redirectField.value = redirectPath;
    form.appendChild(redirectField);

    // Add form to page, submit it, then remove it
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  },
});
